import * as React from "react";
import { ItemKeyHelper } from "components/utility/ItemKeyHelper";
import LinksGridItem from "components/flexComponents/Links/GridView/LinksGridItem";
import { withStores } from "stores";
import { LinkDialog } from "components/flexComponents/Links/GridView/LinkDialog";
import { UitkLayoutGrid } from "uitk-react-layout-grid";
import { UitkCard, UitkCardContentSection } from "uitk-react-cards";
import { QueryRoute, RouteStore } from "bernie-core";
import { ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";
import { Viewport, ViewSmall, ViewMedium, ViewLarge, Layer } from "bernie-view";
import { observer } from "mobx-react";
import { UitkSpacing } from "uitk-react-spacing";
import { BlossomComponent } from "src/components/flexFramework/domain/BlossomComponent";

interface LinksGridWithDialogProps {
  routeStore: RouteStore;
  groups: BlossomComponent[];
  view: string;
  id: string;
  context: ExtendedContextStore;
}

const LinksGridWithDialog = withStores("routeStore")(
  observer((props: LinksGridWithDialogProps) => {
    const { routeStore, groups, view, id, context } = props;
    const linkRef = React.useRef<any>();
    const keyHelper = new ItemKeyHelper("LinksGroup");
    const dialogId = `linksDialog-${id}`;

    const onDismiss = () => {
      routeStore.goBack();
      linkRef.current?.focus();
    };

    const setLinkReference = (linkReference: React.MutableRefObject<HTMLElement>) =>
      (linkRef.current = linkReference.current);

    return (
      <Viewport>
        <ViewSmall>
          <LinksGridWithDialogDom
            routeStore={routeStore}
            groups={groups}
            view={view}
            id={id}
            context={context}
            columns={1}
            keyHelper={keyHelper}
            dialogId={dialogId}
            onDismiss={onDismiss}
            setLinkRef={setLinkReference}
          />
        </ViewSmall>
        <ViewMedium>
          <LinksGridWithDialogDom
            routeStore={routeStore}
            groups={groups}
            view={view}
            id={id}
            context={context}
            columns={groups.length === 1 ? 1 : 2}
            keyHelper={keyHelper}
            dialogId={dialogId}
            onDismiss={onDismiss}
            setLinkRef={setLinkReference}
          />
        </ViewMedium>
        <ViewLarge>
          <LinksGridWithDialogDom
            routeStore={routeStore}
            groups={groups}
            view={view}
            id={id}
            context={context}
            columns={groups.length === 1 ? 1 : 3}
            keyHelper={keyHelper}
            dialogId={dialogId}
            onDismiss={onDismiss}
            setLinkRef={setLinkReference}
          />
        </ViewLarge>
      </Viewport>
    );
  })
);

interface LinksGridWithDialogDomProps {
  routeStore: RouteStore;
  groups: BlossomComponent[];
  view: string;
  id: string;
  context: ExtendedContextStore;
  columns: any;
  keyHelper: ItemKeyHelper;
  dialogId: string;
  onDismiss: () => void;
  setLinkRef: (ref: React.RefObject<HTMLElement>) => void;
}

const LinksGridWithDialogDom = ({
  routeStore,
  groups,
  view,
  id,
  context,
  columns,
  keyHelper,
  dialogId,
  onDismiss,
  setLinkRef,
}: LinksGridWithDialogDomProps) => {
  const linksCardView = view === "standard-link" && groups.length === 1 ? "unset" : "two";

  return (
    <div className="LinksGridWithDialog">
      <UitkCard>
        <UitkSpacing padding={{ inline: linksCardView }}>
          <UitkCardContentSection padded={false}>
            <UitkLayoutGrid space="one" columns={columns}>
              {groups.map((group) => (
                <LinksGridItem
                  key={keyHelper.next()}
                  view={view}
                  group={group}
                  routeStore={routeStore}
                  id={id}
                  context={context}
                  setLinkRef={setLinkRef}
                />
              ))}
              <QueryRoute query={{ pwaDialog: dialogId }}>
                <Layer id={dialogId} onDismiss={onDismiss}>
                  <LinkDialog key={keyHelper.next()} id={id} onDismiss={onDismiss} />
                </Layer>
              </QueryRoute>
            </UitkLayoutGrid>
          </UitkCardContentSection>
        </UitkSpacing>
      </UitkCard>
    </div>
  );
};

export default LinksGridWithDialog;
